(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcementmnsy"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.anncmnsy').forEach(function(bar){
    var track = bar.querySelector('.anncmnsy__track');
    if (!track || !track.children.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var base = track.innerHTML;
    var guard = 0;
    while (track.scrollWidth < bar.offsetWidth && guard < 40) { track.innerHTML += base; guard++; }
    var oneSet = track.scrollWidth;
    track.innerHTML += track.innerHTML;
    var speed = parseFloat(bar.getAttribute('data-speed')) || 25;
    track.style.setProperty('--annc-duration', (oneSet / speed) + 's');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heroslidemnsy"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initHeroslide(root){
    if(!root || root.dataset.hsmInit === 'true') return;
    root.dataset.hsmInit = 'true';
    var slides = root.querySelectorAll('.hsm-slide');
    var dots = root.querySelectorAll('.hsm-dot');
    if(slides.length < 2) return;
    var interval = parseInt(root.dataset.interval || '6000', 10);
    var autoplay = root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mqM = window.matchMedia('(max-width: 749px)');
    var idx = 0, timer = null;

    function tone(){
      var s = slides[idx];
      var light = s.classList.contains('hsm-slide--split') || (s.classList.contains('hsm-slide--bleed') && mqM.matches);
      root.classList.toggle('hsm-light', light);
    }
    function go(i, user){
      idx = (i + slides.length) % slides.length;
      slides.forEach(function(s, n){ s.classList.toggle('is-active', n === idx); });
      dots.forEach(function(d, n){
        d.classList.remove('is-active');
        if(n === idx){ void d.offsetWidth; d.classList.add('is-active'); }
      });
      tone();
      if(user) restart();
    }
    function restart(){
      if(timer) clearInterval(timer);
      if(autoplay) timer = setInterval(function(){ go(idx + 1); }, interval);
    }

    dots.forEach(function(d){
      d.addEventListener('click', function(){ go(parseInt(d.dataset.dotIndex, 10), true); });
    });
    var prev = root.querySelector('.hsm-arrow--prev');
    var next = root.querySelector('.hsm-arrow--next');
    if(prev) prev.addEventListener('click', function(){ go(idx - 1, true); });
    if(next) next.addEventListener('click', function(){ go(idx + 1, true); });
    root.addEventListener('pointerenter', function(e){ if(e.pointerType === 'mouse'){ root.classList.add('is-paused'); if(timer) clearInterval(timer); } });
    root.addEventListener('pointerleave', function(e){ if(e.pointerType === 'mouse'){ root.classList.remove('is-paused'); restart(); } });
    root.addEventListener('keydown', function(e){
      if(e.key === 'ArrowRight') go(idx + 1, true);
      if(e.key === 'ArrowLeft') go(idx - 1, true);
    });
    var tx = 0, ty = 0;
    root.addEventListener('touchstart', function(e){ tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, {passive: true});
    root.addEventListener('touchend', function(e){
      var dx = e.changedTouches[0].clientX - tx;
      var dy = e.changedTouches[0].clientY - ty;
      if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) go(idx + (dx < 0 ? 1 : -1), true);
    }, {passive: true});
    if(mqM.addEventListener) mqM.addEventListener('change', tone);

    root.hsmGo = function(i){ go(i, false); if(timer) clearInterval(timer); };
    root.hsmResume = restart;
    tone();
    restart();
  }

  function initAll(scope){
    (scope || document).querySelectorAll('.heroslidemnsy').forEach(initHeroslide);
  }
  initAll();

  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
  document.addEventListener('shopify:block:select', function(e){
    var slide = e.target.closest ? e.target.closest('.hsm-slide') : null;
    var root = e.target.closest ? e.target.closest('.heroslidemnsy') : null;
    if(slide && root && root.hsmGo) root.hsmGo(parseInt(slide.dataset.slideIndex, 10));
  });
  document.addEventListener('shopify:block:deselect', function(e){
    var root = e.target.closest ? e.target.closest('.heroslidemnsy') : null;
    if(root && root.hsmResume) root.hsmResume();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopoverlaymnsy"] && !Shopify.designMode) return;
  try {
    
class ShopOverlayMnsy extends HTMLElement {
  connectedCallback() {
    this.trigger = (this.getAttribute('data-trigger') || 'Shop').trim().toLowerCase();
    this._onClick = this.onClick.bind(this);
    this._onKey = this.onKey.bind(this);
    document.addEventListener('click', this._onClick);
    document.addEventListener('keydown', this._onKey);
    if (!this.isDesktop) this.initMobile();
  }
  disconnectedCallback() {
    document.removeEventListener('click', this._onClick);
    document.removeEventListener('keydown', this._onKey);
  }
  get isDesktop() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }
  open() { this.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
  close() { this.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  onKey(e) { if (e.key === 'Escape') this.close(); }
  onClick(e) {
    if (e.target.closest('[data-shopov-close]')) { this.close(); return; }
    if (!this.isDesktop) return;
    var a = e.target.closest('a');
    if (!a || this.contains(a)) return;
    if ((a.textContent || '').trim().toLowerCase() !== this.trigger) return;
    e.preventDefault();
    this.open();
  }
  initMobile() {
    var self = this;
    var mount = function () { self.mountAccordion(); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
    else mount();
    var details = document.getElementById('Details-menu-drawer-container') || document.querySelector('details.menu-drawer-container');
    if (details) details.addEventListener('toggle', function () { if (details.open) self.mountAccordion(); });
  }
  drawerShopItem() {
    var links = document.querySelectorAll('.menu-drawer a, .menu-drawer__navigation a');
    for (var i = 0; i < links.length; i++) {
      if ((links[i].textContent || '').trim().toLowerCase() === this.trigger) return links[i];
    }
    return null;
  }
  mountAccordion() {
    var body = this.querySelector('.shopov__body');
    if (!body) return;
    var a = this.drawerShopItem();
    if (!a) return;
    var li = a.closest('li');
    if (!li || !li.parentNode) return;
    var next = li.nextElementSibling;
    if (next && next.classList && next.classList.contains('shopov-inline')) return;
    var foot = this.querySelector('.shopov__foot');

    var panel = document.createElement('li');
    panel.className = 'shopov-inline';
    panel.innerHTML = body.innerHTML;

    var cols = panel.querySelectorAll('.shopov__col');
    for (var i = 0; i < cols.length; i++) {
      (function (col, first) {
        var h = col.querySelector('.shopov__h4');
        if (!h) return;
        if (first) col.classList.add('is-open');
        h.setAttribute('role', 'button');
        h.setAttribute('tabindex', '0');
        h.setAttribute('aria-expanded', first ? 'true' : 'false');
        var caret = document.createElement('span');
        caret.className = 'shopov-acc-caret';
        h.appendChild(caret);
        var toggle = function () {
          var open = col.classList.toggle('is-open');
          h.setAttribute('aria-expanded', open ? 'true' : 'false');
        };
        h.addEventListener('click', toggle);
        h.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
        });
      })(cols[i], i === 0);
    }

    if (foot) panel.insertAdjacentHTML('beforeend', foot.innerHTML);
    li.parentNode.insertBefore(panel, li.nextSibling);
  }
}
if (!customElements.get('shop-overlay-mnsy')) customElements.define('shop-overlay-mnsy', ShopOverlayMnsy);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trustbarmnsy"] && !Shopify.designMode) return;
  try {
    
class TrustbarCarouselMnsy extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('.tb__grid');
    this.slides = Array.prototype.slice.call(this.querySelectorAll('.tb__usp'));
    this.dotsEl = this.querySelector('.tb__dots');
    this.i = 0;
    if (this.slides.length < 2) return;
    this.mq = matchMedia('(max-width: 749px)');
    this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
    this.buildDots();
    this._apply = this.apply.bind(this);
    this.mq.addEventListener('change', this._apply);
    this.reduce.addEventListener('change', this._apply);
    this.grid.addEventListener('touchstart', (e) => { this.x0 = e.touches[0].clientX; }, { passive: true });
    this.grid.addEventListener('touchend', (e) => {
      if (this.x0 == null) return;
      var dx = e.changedTouches[0].clientX - this.x0;
      if (Math.abs(dx) > 30) { this.go(this.i + (dx < 0 ? 1 : -1)); this.start(); }
      this.x0 = null;
    });
    this.apply();
  }
  disconnectedCallback() {
    this.stop();
    if (this.mq) this.mq.removeEventListener('change', this._apply);
    if (this.reduce) this.reduce.removeEventListener('change', this._apply);
  }
  buildDots() {
    this.dotsEl.innerHTML = '';
    this.dots = this.slides.map((s, k) => {
      var d = document.createElement('span');
      d.className = 'tb__dot' + (k === 0 ? ' on' : '');
      d.addEventListener('click', () => { this.go(k); this.start(); });
      this.dotsEl.appendChild(d);
      return d;
    });
  }
  apply() {
    if (this.mq.matches && !this.reduce.matches) { this.classList.add('is-carousel'); this.go(this.i); this.start(); }
    else { this.classList.remove('is-carousel'); this.stop(); this.slides.forEach((s) => { s.style.display = ''; }); }
  }
  go(k) {
    this.i = (k + this.slides.length) % this.slides.length;
    this.slides.forEach((s, j) => { s.style.display = (j === this.i ? 'flex' : 'none'); });
    if (this.dots) this.dots.forEach((d, j) => d.classList.toggle('on', j === this.i));
  }
  start() { this.stop(); this.timer = setInterval(() => this.go(this.i + 1), 3500); }
  stop() { if (this.timer) clearInterval(this.timer); }
}
if (!customElements.get('trustbar-carousel-mnsy')) customElements.define('trustbar-carousel-mnsy', TrustbarCarouselMnsy);

  } catch(e) { console.error(e); }
})();
})();
